import { useRef } from 'react';

export const DEFAULT_REM = 16;

export default (): number => {
  if (typeof document !== 'object' || !document.documentElement) {
    return DEFAULT_REM;
  }

  const { current: css } = useRef(
    window.getComputedStyle(document.documentElement),
  );

  const fontSizeParsed = parseInt((css.fontSize || '').replace('px', ''), 10);

  return Number.isNaN(fontSizeParsed) ? DEFAULT_REM : fontSizeParsed;
};
